import { RootState } from 'src/types';

export const itinerarySelector = (state: RootState) => state?.itinerary?.itinerary;